import { useLDClient } from 'launchdarkly-react-client-sdk';

/** LaunchDarkly flags the API accepts as `flag=<name>` to run a route's release-candidate query. */
type ReleaseFlag = 'audience_page_backfill';

/** Returns `flagName` when that LaunchDarkly flag is on, otherwise `undefined`. */
const useReleaseFlag = (flagName: ReleaseFlag): ReleaseFlag | undefined => {
  const ldClient = useLDClient();
  return ldClient?.variation(flagName, false) ? flagName : undefined;
};

export default useReleaseFlag;
